import { render, staticRenderFns } from "./ArticleEight.vue?vue&type=template&id=f5432b1a&scoped=true"
import script from "./ArticleEight.vue?vue&type=script&lang=js"
export * from "./ArticleEight.vue?vue&type=script&lang=js"
import style0 from "./ArticleEight.vue?vue&type=style&index=0&id=f5432b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5432b1a",
  null
  
)

export default component.exports